var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReportV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 4,
    height: 8,
    rx: 1,
    fill: "#E6E6E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4,
    width: 4,
    height: 15,
    rx: 1,
    fill: "#E6E6E6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 8,
    width: 4,
    height: 11,
    rx: 1,
    fill: "#E6E6E6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 20.25,
    width: 20,
    height: 1.5,
    rx: 0.75,
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReportV2);
export default __webpack_public_path__ + "static/media/ic_report_v2.67a3624003b8d5b54ce66f13bef4f304.svg";
export { ForwardRef as ReactComponent };